var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.show ? _c('div', {
    staticClass: "p-2 rounded-lg",
    attrs: {
      "id": _vm.id,
      "aria-labelledby": `${_vm.id}-tab`,
      "role": "tabpanel"
    }
  }, [_vm.isLazyLoad === false || _vm.isLazyLoad && _vm.lazyShow ? _vm._t("default") : _vm._e()], 2) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }